<template>
  <path
    data-name="Trazado 3557"
    d="m52.787 75.909.524-3.416h-3.277v-2.215a1.708 1.708 0 0 1 1.926-1.846h1.49v-2.907a18.154 18.154 0 0 0-2.645-.231c-2.7 0-4.463 1.636-4.463 4.6v2.6h-3v3.416h3v8.256a11.919 11.919 0 0 0 3.692 0v-8.257z"
    transform="translate(-43.342 -65.294)"
  />
</template>
